import React, { useState } from "react";
import { Link } from "react-router-dom";

const BusinessPlan = () => {
  const [selectedPdf, setSelectedPdf] = useState("ENGLISH");

  const pdfOptions = [
    { key: "ENGLISH", label: "English PDF", file: "/ABMGROUPONE_ENGLISH.pdf" },
    { key: "HINDI", label: "Hindi PDF", file: "/ABMGROUPONE_HINDI.pdf" },
  ];

  return (
    <div className="mt-20 bg-slate-50 text-slate-900">
      <div className=" mx-auto px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-8 rounded-3xl bg-white p-6 shadow-xl shadow-slate-200/80">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-sm uppercase tracking-[0.28em] text-amber-500 font-semibold">ABM Group One</p>
              <h1 className="mt-3 text-3xl font-extrabold text-slate-900 sm:text-4xl">
                Business Plan
              </h1>
              <p className="mt-3 max-w-2xl text-sm text-slate-600 sm:text-base">
                Access the ABM Group One business plan and review the program details in PDF format.
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <div className="flex flex-wrap gap-2">
                {pdfOptions.map((option) => {
                  const isActive = selectedPdf === option.key;
                  return (
                    <button
                      key={option.key}
                      type="button"
                      onClick={() => setSelectedPdf(option.key)}
                      className={`rounded-full px-4 py-2 text-sm font-semibold transition ${
                        isActive
                          ? "bg-slate-900 text-white shadow-lg shadow-slate-900/10"
                          : "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50"
                      }`}
                    >
                      {option.label}
                    </button>
                  );
                })}
              </div>
              <Link
                to="/"
                className="inline-flex items-center justify-center rounded-full border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </div>

        <div className="grid gap-6 lg:grid-cols-[2.5fr_1fr]">
          <div className="rounded-3xl bg-white p-6 shadow-xl shadow-slate-200/80">
            <div className="h-[calc(100vh-180px)] overflow-hidden rounded-3xl border border-slate-200 bg-slate-950">
              <iframe
                title="ABM Group One Business Plan"
                src={pdfOptions.find((option) => option.key === selectedPdf)?.file || pdfOptions[0].file}
                className="h-full w-full border-0"
              />
            </div>
          </div>

          <aside className="space-y-6 rounded-3xl bg-slate-900 p-6 text-white shadow-xl shadow-slate-900/60">
            <div>
              <p className="text-sm uppercase tracking-[0.25em] text-amber-300">Business Plan Highlights</p>
              <h2 className="mt-3 text-2xl font-bold">Quick overview</h2>
              <p className="mt-3 text-sm leading-7 text-slate-300">
                Review the full ABM Group One strategy document, including the compensation plan, product roadmap, partner benefits, and growth model.
              </p>
            </div>
            <div className="space-y-4 rounded-3xl bg-slate-800 p-5">
              <div className="flex items-start gap-3">
                <div className="mt-1 h-2.5 w-2.5 rounded-full bg-amber-400" />
                <div>
                  <p className="font-semibold text-slate-100">Downloadable PDF</p>
                  <p className="text-sm text-slate-400">Open the business plan in a new tab or download it.</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="mt-1 h-2.5 w-2.5 rounded-full bg-sky-400" />
                <div>
                  <p className="font-semibold text-slate-100">Easy sharing</p>
                  <p className="text-sm text-slate-400">Send the plan PDF to prospects, partners, and stakeholders.</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="mt-1 h-2.5 w-2.5 rounded-full bg-emerald-400" />
                <div>
                  <p className="font-semibold text-slate-100">Business guidance</p>
                  <p className="text-sm text-slate-400">Use the plan to explain income streams, team building, and product strategy.</p>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default BusinessPlan;
